import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

const CustomSearch = ({ onSearch }: { onSearch: (text: string) => void }) => {
  return (
    <Search
      prefix={<SearchOutlined />}
      className="w"
      placeholder="ค้นหา"
      allowClear
      size="large"
      style={{
        width: 250,
      }}
      onChange={e => onSearch(e.target.value)}
    />
  );
};

export default CustomSearch;
